import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IImageFilters } from '../../imageFilters.model';
import { FiltersDropdownRow } from './FiltersDropdownRow';

interface IFilterInfoProps {
  imageFilters: IImageFilters;
}

export const ImageNameFilterInfo = observer((props: IFilterInfoProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <>
      {props.imageFilters.imageName.length > 0 && (
        <FiltersDropdownRow
          label={t('image_filters.image_name')}
          count={1}
        >
          <>{props.imageFilters.imageName}</>
        </FiltersDropdownRow>
      )}
    </>
  );
});
